export const property = {
  success: true,
  data: {
    id: '45',
    hotel_features_custom: {
      vasya: 'vasya',
      petya: 'petya',
    },
    hotel_features: {
      '2': {
        name: 'ATM on site',
        lang: {
          en: 'Automated teller (ATM)',
          'pt-br': 'Caixa eletrônico',
          ja: 'Automated teller (ATM)',
          zh: 'Automated teller (ATM)',
          es: 'Automated teller (ATM)',
          it: 'Automated teller (ATM)',
          ru: 'Automated teller (ATM)',
          hi: 'Automated teller (ATM)',
          fr: 'Automated teller (ATM)',
          de: 'Automated teller (ATM)',
          et: 'Automated teller (ATM)',
          nl: 'Automated teller (ATM)',
          pl: 'Automated teller (ATM)',
          fi: 'Automated teller (ATM)',
          el: 'Automated teller (ATM)',
          th: 'Automated teller (ATM)',
          cn: 'Automated teller (ATM)',
          he: 'Automated teller (ATM)',
          ko: 'Automated teller (ATM)',
          ua: 'Automated teller (ATM)',
          sv: 'Automated teller (ATM)',
          no: 'Automated teller (ATM)',
          lt: 'Automated teller (ATM)',
          vn: 'Automated teller (ATM)',
          hu: 'Automated teller (ATM)',
          sk: 'Automated teller (ATM)',
          cs: 'Automated teller (ATM)',
          mk: 'Automated teller (ATM)',
          ro: 'Automated teller (ATM)',
          ar: 'Automated teller (ATM)',
        },
        slug: 'atm-on-site',
      },
      '4': {
        name: 'Concierge',
        lang: {
          en: 'Concierge desk',
          'pt-br': 'Concierge',
          ja: 'Concierge desk',
          zh: 'Concierge desk',
          es: 'Concierge desk',
          it: 'Concierge desk',
          ru: 'Concierge desk',
          hi: 'Concierge desk',
          fr: 'Concierge desk',
          de: 'Concierge desk',
          et: 'Concierge desk',
          nl: 'Concierge desk',
          pl: 'Concierge desk',
          fi: 'Concierge desk',
          el: 'Concierge desk',
          th: 'Concierge desk',
          cn: 'Concierge desk',
          he: 'Concierge desk',
          ko: 'Concierge desk',
          ua: 'Concierge desk',
          sv: 'Concierge desk',
          no: 'Concierge desk',
          lt: 'Concierge desk',
          vn: 'Concierge desk',
          hu: 'Concierge desk',
          sk: 'Concierge desk',
          cs: 'Concierge desk',
          mk: 'Concierge desk',
          ro: 'Concierge desk',
          ar: 'Concierge desk',
        },
        slug: 'concierge',
      },
      '6': {
        name: 'Fax services',
        lang: {
          en: 'Fax services',
          'pt-br': 'Envio de fax',
          ja: 'Fax services',
          zh: 'Fax services',
          es: 'Fax services',
          it: 'Fax services',
          ru: 'Fax services',
          hi: 'Fax services',
          fr: 'Fax services',
          de: 'Fax services',
          et: 'Fax services',
          nl: 'Fax services',
          pl: 'Fax services',
          fi: 'Fax services',
          el: 'Fax services',
          th: 'Fax services',
          cn: 'Fax services',
          he: 'Fax services',
          ko: 'Fax services',
          ua: 'Fax services',
          sv: 'Fax services',
          no: 'Fax services',
          lt: 'Fax services',
          vn: 'Fax services',
          hu: 'Fax services',
          sk: 'Fax services',
          cs: 'Fax services',
          mk: 'Fax services',
          ro: 'Fax services',
          ar: 'Fax services',
        },
        slug: 'fax-services',
      },
      '8': {
        name: 'Foreign currency exchange',
        lang: {
          en: 'Foreign currency exchange',
          'pt-br': 'Câmbio',
          ja: 'Foreign currency exchange',
          zh: 'Foreign currency exchange',
          es: 'Foreign currency exchange',
          it: 'Foreign currency exchange',
          ru: 'Foreign currency exchange',
          hi: 'Foreign currency exchange',
          fr: 'Foreign currency exchange',
          de: 'Foreign currency exchange',
          et: 'Foreign currency exchange',
          nl: 'Foreign currency exchange',
          pl: 'Foreign currency exchange',
          fi: 'Foreign currency exchange',
          el: 'Foreign currency exchange',
          th: 'Foreign currency exchange',
          cn: 'Foreign currency exchange',
          he: 'Foreign currency exchange',
          ko: 'Foreign currency exchange',
          ua: 'Foreign currency exchange',
          sv: 'Foreign currency exchange',
          no: 'Foreign currency exchange',
          lt: 'Foreign currency exchange',
          vn: 'Foreign currency exchange',
          hu: 'Foreign currency exchange',
          sk: 'Foreign currency exchange',
          cs: 'Foreign currency exchange',
          mk: 'Foreign currency exchange',
          ro: 'Foreign currency exchange',
          ar: 'Foreign currency exchange',
        },
        slug: 'foreign-currency-exchange',
      },
      '12': {
        name: 'Lounge',
        lang: {
          en: 'Lounge',
          'pt-br': 'Lounge',
          ja: 'Lounge',
          zh: 'Lounge',
          es: 'Lounge',
          it: 'Lounge',
          ru: 'Lounge',
          hi: 'Lounge',
          fr: 'Lounge',
          de: 'Lounge',
          et: 'Lounge',
          nl: 'Lounge',
          pl: 'Lounge',
          fi: 'Lounge',
          el: 'Lounge',
          th: 'Lounge',
          cn: 'Lounge',
          he: 'Lounge',
          ko: 'Lounge',
          ua: 'Lounge',
          sv: 'Lounge',
          no: 'Lounge',
          lt: 'Lounge',
          vn: 'Lounge',
          hu: 'Lounge',
          sk: 'Lounge',
          cs: 'Lounge',
          mk: 'Lounge',
          ro: 'Lounge',
          ar: 'Lounge',
        },
        slug: 'lounge',
      },
      '18': {
        name: 'Safe deposit boxes at front desk',
        lang: {
          en: 'Safe deposit boxes at front desk',
          'pt-br': 'Cofres na portaria',
          ja: 'Safe deposit boxes at front desk',
          zh: 'Safe deposit boxes at front desk',
          es: 'Safe deposit boxes at front desk',
          it: 'Safe deposit boxes at front desk',
          ru: 'Safe deposit boxes at front desk',
          hi: 'Safe deposit boxes at front desk',
          fr: 'Safe deposit boxes at front desk',
          de: 'Safe deposit boxes at front desk',
          et: 'Safe deposit boxes at front desk',
          nl: 'Safe deposit boxes at front desk',
          pl: 'Safe deposit boxes at front desk',
          fi: 'Safe deposit boxes at front desk',
          el: 'Safe deposit boxes at front desk',
          th: 'Safe deposit boxes at front desk',
          cn: 'Safe deposit boxes at front desk',
          he: 'Safe deposit boxes at front desk',
          ko: 'Safe deposit boxes at front desk',
          ua: 'Safe deposit boxes at front desk',
          sv: 'Safe deposit boxes at front desk',
          no: 'Safe deposit boxes at front desk',
          lt: 'Safe deposit boxes at front desk',
          vn: 'Safe deposit boxes at front desk',
          hu: 'Safe deposit boxes at front desk',
          sk: 'Safe deposit boxes at front desk',
          cs: 'Safe deposit boxes at front desk',
          mk: 'Safe deposit boxes at front desk',
          ro: 'Safe deposit boxes at front desk',
          ar: 'Safe deposit boxes at front desk',
        },
        slug: 'safety-deposit-box',
      },
      '19': {
        name: 'Shoeshine',
        lang: {
          en: 'Shoe-shine service',
          'pt-br': 'Engraxate',
          ja: 'Shoe-shine service',
          zh: 'Shoe-shine service',
          es: 'Shoe-shine service',
          it: 'Shoe-shine service',
          ru: 'Shoe-shine service',
          hi: 'Shoe-shine service',
          fr: 'Shoe-shine service',
          de: 'Shoe-shine service',
          et: 'Shoe-shine service',
          nl: 'Shoe-shine service',
          pl: 'Shoe-shine service',
          fi: 'Shoe-shine service',
          el: 'Shoe-shine service',
          th: 'Shoe-shine service',
          cn: 'Shoe-shine service',
          he: 'Shoe-shine service',
          ko: 'Shoe-shine service',
          ua: 'Shoe-shine service',
          sv: 'Shoe-shine service',
          no: 'Shoe-shine service',
          lt: 'Shoe-shine service',
          vn: 'Shoe-shine service',
          hu: 'Shoe-shine service',
          sk: 'Shoe-shine service',
          cs: 'Shoe-shine service',
          mk: 'Shoe-shine service',
          ro: 'Shoe-shine service',
          ar: 'Shoe-shine service',
        },
        slug: 'shoeshine',
      },
      '21': {
        name: 'Valet service',
        lang: {
          en: 'Valet service',
          'pt-br': 'Manobrista',
          ja: 'Valet service',
          zh: 'Valet service',
          es: 'Valet service',
          it: 'Valet service',
          ru: 'Valet service',
          hi: 'Valet service',
          fr: 'Valet service',
          de: 'Valet service',
          et: 'Valet service',
          nl: 'Valet service',
          pl: 'Valet service',
          fi: 'Valet service',
          el: 'Valet service',
          th: 'Valet service',
          cn: 'Valet service',
          he: 'Valet service',
          ko: 'Valet service',
          ua: 'Valet service',
          sv: 'Valet service',
          no: 'Valet service',
          lt: 'Valet service',
          vn: 'Valet service',
          hu: 'Valet service',
          sk: 'Valet service',
          cs: 'Valet service',
          mk: 'Valet service',
          ro: 'Valet service',
          ar: 'Valet service',
        },
        slug: 'valet-service',
      },
    },
    cards_frontend_enabled: '1',
    payment_gateway: 'tokenex',
    payments_credit_cards: [{ payment_code: 'AMEX' }],
    same_day_reservation: '1',
    hotel_about: 'English description',
    hotel_about_langs: {
      en: 'English description',
      'pt-br': 'Descrição em português do Brasil',
      es: 'ADF',
      ru: 'ADF',
      ua: '',
      it: 'ADF',
      de: 'ADF',
      fr: '',
      et: '',
      pl: '',
      nl: '',
      fi: '',
      el: '',
      ja: '',
      th: '',
      cn: '',
      he: '',
      ko: '',
      sv: '',
      no: '',
      lt: '',
      vn: '',
      hu: '',
      sk: '',
      cs: '',
      ro: '',
    },
    hotel_address_country: 'UA',
    default_lang: 'en',
    hotel_email: 'some@hotel.test',
    primary_name: 'test test',
    ga_client_id: '',
    facebook_pixel_id: null,
    ga_primary_domain: '',
    google_conversion_id: '',
    google_conversion_label: '',
    ga_client_id_for_admin: null,
    google_conversion_id_for_admin: '',
    google_conversion_label_for_admin: '',
    ga_primary_domain_for_admin: '',
    meta_tags_for_admin_booking_engine: null,
    meta_tags_for_admin_booking_engine_confirm: null,
    paypal_email: '',
    booking_display_photos: '1',
    booking_logo: false,
    account_status: 'regular',
    myallocator_cc: '0',
    gdpr_enabled: '0',
    room_features_custom: {
      'ROOM AM': 'ROOM AM',
    },
    room_features: {
      '16': {
        name: 'Microwave',
        lang: {
          en: 'Microwave',
          'pt-br': 'Micro-ondas',
          ja: 'Microwave',
          zh: 'Microwave',
          es: 'Microwave',
          it: 'Microwave',
          ru: 'Microwave',
          hi: 'Microwave',
          fr: 'Microwave',
          de: 'Microwave',
          et: 'Microwave',
          nl: 'Microwave',
          pl: 'Microwave',
          fi: 'Microwave',
          el: 'Microwave',
          th: 'Microwave',
          cn: 'Microwave',
          he: 'Microwave',
          ko: 'Microwave',
          ua: 'Microwave',
          sv: 'Microwave',
          no: 'Microwave',
          lt: 'Microwave',
          vn: 'Microwave',
          hu: 'Microwave',
          sk: 'Microwave',
          cs: 'Microwave',
          mk: 'Microwave',
          ro: 'Microwave',
          ar: 'Microwave',
        },
      },
      '18': {
        name: 'Minibar',
        lang: {
          en: 'Minibar',
          'pt-br': 'Frigobar',
          ja: 'Minibar',
          zh: 'Minibar',
          es: 'Minibar',
          it: 'Minibar',
          ru: 'Minibar',
          hi: 'Minibar',
          fr: 'Minibar',
          de: 'Minibar',
          et: 'Minibar',
          nl: 'Minibar',
          pl: 'Minibar',
          fi: 'Minibar',
          el: 'Minibar',
          th: 'Minibar',
          cn: 'Minibar',
          he: 'Minibar',
          ko: 'Minibar',
          ua: 'Minibar',
          sv: 'Minibar',
          no: 'Minibar',
          lt: 'Minibar',
          vn: 'Minibar',
          hu: 'Minibar',
          sk: 'Minibar',
          cs: 'Minibar',
          mk: 'Minibar',
          ro: 'Minibar',
          ar: 'Minibar',
        },
      },
      '19': {
        name: 'AM / FM radio',
        lang: {
          en: 'AM / FM radio',
          'pt-br': 'Rádio AM/FM',
          ja: 'AM / FM radio',
          zh: 'AM / FM radio',
          es: 'AM / FM radio',
          it: 'AM / FM radio',
          ru: 'AM / FM radio',
          hi: 'AM / FM radio',
          fr: 'AM / FM radio',
          de: 'AM / FM radio',
          et: 'AM / FM radio',
          nl: 'AM / FM radio',
          pl: 'AM / FM radio',
          fi: 'AM / FM radio',
          el: 'AM / FM radio',
          th: 'AM / FM radio',
          cn: 'AM / FM radio',
          he: 'AM / FM radio',
          ko: 'AM / FM radio',
          ua: 'AM / FM radio',
          sv: 'AM / FM radio',
          no: 'AM / FM radio',
          lt: 'AM / FM radio',
          vn: 'AM / FM radio',
          hu: 'AM / FM radio',
          sk: 'AM / FM radio',
          cs: 'AM / FM radio',
          mk: 'AM / FM radio',
          ro: 'AM / FM radio',
          ar: 'AM / FM radio',
        },
      },
      '20': {
        name: 'Wireless internet (WiFi)',
        lang: {
          en: 'Wireless internet (WiFi)',
          'pt-br': 'Internet sem fio',
          ja: 'Wireless internet (WiFi)',
          zh: 'Wireless internet (WiFi)',
          es: 'Wireless internet (WiFi)',
          it: 'Wireless internet (WiFi)',
          ru: 'Wireless internet (WiFi)',
          hi: 'Wireless internet (WiFi)',
          fr: 'Wireless internet (WiFi)',
          de: 'Wireless internet (WiFi)',
          et: 'Wireless internet (WiFi)',
          nl: 'Wireless internet (WiFi)',
          pl: 'Wireless internet (WiFi)',
          fi: 'Wireless internet (WiFi)',
          el: 'Wireless internet (WiFi)',
          th: 'Wireless internet (WiFi)',
          cn: 'Wireless internet (WiFi)',
          he: 'Wireless internet (WiFi)',
          ko: 'Wireless internet (WiFi)',
          ua: 'Wireless internet (WiFi)',
          sv: 'Wireless internet (WiFi)',
          no: 'Wireless internet (WiFi)',
          lt: 'Wireless internet (WiFi)',
          vn: 'Wireless internet (WiFi)',
          hu: 'Wireless internet (WiFi)',
          sk: 'Wireless internet (WiFi)',
          cs: 'Wireless internet (WiFi)',
          mk: 'Wireless internet (WiFi)',
          ro: 'Wireless internet (WiFi)',
          ar: 'Wireless internet (WiFi)',
        },
      },
    },
    additional_photos: [
      {
        id: '2194',
        parent_id: '0',
        TYPE: 'public',
        path: 'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
        original_name: 'room1-1.jpg',
        size: '164873',
        mime: 'image/jpeg',
        uploaded_at: '2023-02-28 03:41:53',
        utype: '',
        crop_param: '',
        owner_id: '1',
        owner_type: 'hotel',
        section: '',
        image_width: '700',
        image_height: '490',
        alt: '',
        full_path:
          'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
        cropped_image:
          'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
        gallery_path:
          'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
        thumb_path:
          'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
      },
      {
        id: '2197',
        parent_id: '0',
        TYPE: 'public',
        path: 'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        original_name: 'room1-2.jpg',
        size: '164483',
        mime: 'image/jpeg',
        uploaded_at: '2023-02-28 03:41:54',
        utype: '',
        crop_param: '',
        owner_id: '1',
        owner_type: 'hotel',
        section: '',
        image_width: '700',
        image_height: '490',
        alt: '',
        full_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        cropped_image:
          'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        gallery_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        thumb_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
      },
      {
        id: '2200',
        parent_id: '0',
        TYPE: 'public',
        path: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        original_name: 'room1-3.jpg',
        size: '216233',
        mime: 'image/jpeg',
        uploaded_at: '2023-02-28 03:41:55',
        utype: '',
        crop_param: '',
        owner_id: '1',
        owner_type: 'hotel',
        section: '',
        image_width: '700',
        image_height: '490',
        alt: '',
        full_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        cropped_image:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        gallery_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        thumb_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
      },
      {
        id: '2201',
        parent_id: '0',
        TYPE: 'public',
        path: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        original_name: 'room1-4.jpg',
        size: '183404',
        mime: 'image/jpeg',
        uploaded_at: '2023-02-28 03:41:56',
        utype: '',
        crop_param: '',
        owner_id: '1',
        owner_type: 'hotel',
        section: '',
        image_width: '700',
        image_height: '490',
        alt: '',
        full_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        cropped_image:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        gallery_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        thumb_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
      },
      {
        id: '2200',
        parent_id: '0',
        TYPE: 'public',
        path: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        original_name: 'room1-3.jpg',
        size: '216233',
        mime: 'image/jpeg',
        uploaded_at: '2023-02-28 03:41:55',
        utype: '',
        crop_param: '',
        owner_id: '1',
        owner_type: 'hotel',
        section: '',
        image_width: '700',
        image_height: '490',
        alt: '',
        full_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        cropped_image:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        gallery_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        thumb_path:
          'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
      },
    ],
    show_estimated_arrival_time: '1',
    myallocator_platform: 'PMS',
    is_dev: '0',
    property_id: '1',
    terms_deposit_type: 'percent',
    terms_secure_fixed: '0',
    terms_secure_percent: '30',
    terms_tax_percent: '0',
    terms_cancellation_days: null,
    terms_partial_allowed: null,
    terms_deposit_perc: null,
    terms_full_refund_days: null,
    terms_normal_checkin: '14:00',
    terms_normal_checkout: '12:00',
    terms_late_checkout: '0',
    terms_late_checkout_hour: '10:01',
    terms_late_checkout_type: 'percent',
    terms_late_checkout_val: '50.00',
    set_on: '2023-02-28 03:01:13',
    expired_on: null,
    taxes_included: 'Y',
    included_taxes_type: 'percent',
    terms_tax_fixed: '0',
    fees_included: 'Y',
    fees_included_type: 'percent',
    fees_percent: '0',
    fees_fixed: '0',
    res_need_confirmation: 'N',
    is_own_cancellation: '1',
    custom_cancellation_policy_langs: {
      en: 'This is my custom cancelation policy',
      'pt-br': '',
      es: '',
      ru: '',
      ua: '',
      it: '',
      de: '',
      fr: '',
      et: '',
      pl: '',
      nl: '',
      fi: '',
      el: '',
      ja: '',
      th: '',
      cn: '',
      he: '',
      ko: '',
      sv: '',
      no: '',
      lt: '',
      vn: '',
      hu: '',
      sk: '',
      cs: '',
      ro: '',
    },
    cancellation_policy_allowed: 'Y',
    terms_full_charge_allowed: 'N',
    terms_partial_charge_allowed: 'N',
    terms_no_charge_allowed: 'N',
    terms_full_charge_type: null,
    terms_partial_charge_type: null,
    terms_partial_amount: null,
    terms_full_charge_cancellation_days: null,
    terms_partial_charge_cancellation_days: null,
    terms_no_charge_cancellation_days: null,
    terms_txt_langs: {
      en: 'This is my terms and conditons',
      'pt-br': '',
      es: '',
      ru: '',
      ua: '',
      it: '',
      de: '',
      fr: '',
      et: '',
      pl: '',
      nl: '',
      fi: '',
      el: '',
      ja: '',
      th: '',
      cn: '',
      he: '',
      ko: '',
      sv: '',
      no: '',
      lt: '',
      vn: '',
      hu: '',
      sk: '',
      cs: '',
      ro: '',
    },
    no_availiability_txt_langs: null,
    no_deposit_cc_collect: 'Y',
    full_payment_before_checkin: 'N',
    include_taxes_and_fees_to_deposit: 'N',
    auto_confirmation_pending: 'N',
    basic_stock_inventory_enabled: '0',
    policies_enabled: '1',
    payment_options_enabled: '1',
    ga_enabled: '1',
    booking_lc_block_enabled: '1',
    booking_custom_enabled: '1',
    myallocator_enabled: '4',
    group_housing_enabled: '0',
    booking_engine_colors: '0',
    revenue_allocation: '0',
    hotel_name: '[ MOCK ] Mock property',
    business_name: 'test',
    logo: 'https://mfd-devbox-cloud-front.cloudbeds-dev.com/mfd-devbox-dustin-haggard-35803_main/uploads/1/main_thumb~~63fd67c80a572.jpg',
    logo_original:
      'https://mfd-devbox-cloud-front.cloudbeds-dev.com/mfd-devbox-dustin-haggard-35803_main/uploads/1/main_gallery~~63fd67c7c368e.jpg',
    hotel_address: {
      address1: 'test, test, test, test',
      address2: 'test',
      city: 'Kiev',
      state: '',
      zip: '123123123',
      country: 'UA',
      lat: '0',
      lng: '0',
    },
    contact_first_name: 'Ratslav',
    contact_last_name: '',
    hotel_phone: '111111111111',
    login_email: 'test@test.test',
    hotel_decimal_separator: '',
    hotel_thousand_separator: '',
    print_header_img: null,
    property_lang: 'en',
    default_currency: 'EUR',
    formatted_address: 'test, test, test, test, test, Kiev, 123123123, UA',
    settings: {
      bookingPostalAddress: '0',
      bookingRequireTelephone: '1',
      bookingRequireTermsConditions: '1',
      bookingEmailCustomer: '1',
      bookingNationality: '1',
      bookingGender: '0',
      bookingLimitPerPerson: '0',
      bookingQuantityToSell: '0',
      bookingSettingsCvv: '1',
      askGuestTaxIdNumber: '0',
      askCompanyName: '0',
      askCompanyTaxIdNumber: '0',
      galleryDesign: '0',
      totalPriceForStay: '0',
      hideMap: '0',
      bookingEstimatedArrivalTime: '0',
      isOptInOutEnabledOnBooking: '0',
      optInSettings: null,
      allowedBookingLanguages: [
        'en',
        'pt-br',
        'es',
        'ru',
        'ua',
        'it',
        'de',
        'fr',
        'et',
        'pl',
        'nl',
        'fi',
        'el',
        'ja',
        'th',
        'cn',
        'he',
        'ko',
        'sv',
        'no',
        'lt',
        'vn',
        'hu',
        'sk',
        'cs',
        'ro',
        'ar',
      ],
      bookingRedirectUrl: '0',
      roomTypeBookingSettings: [
        {
          roomTypeId: '141',
          title: 'Room #1',
          bookRoomsOnMyBookings: '0',
          maxRooms: '1',
          bookableLimit: '0',
          capacity: '5',
        },
      ],
    },
    formats: {
      name: 'english',
      native: 'English',
      country: 'United States',
      country_code: 'US',
      native_short: 'En',
      date_format: 'm/d/Y',
      date_format_dashboard: 'MM d, yy',
      mon_decimal_point: '.',
      mon_thousands_sep: ',',
      date_format_full: 'l, F j, Y',
      date_format_short: 'm/d',
      time_format: 'H:i',
      month_first: true,
      phone: '(999) 999-9999',
      locale: 'en_US',
      flag: 'US',
      optional_system_language: false,
      currency_code: 'EUR',
      currency_name: 'Euro',
      currency_symbol: '€',
      currency_position: 'before',
      currency_code_number: '978',
      currency_minor_unit_exponent: 2,
      date_delimiter: '/',
      date_format_wy: 'm/d',
      default_language: 'en',
      default_timezone: 'UTC',
      current_timezone_offset: 0,
    },
  },
};
